const Toast = require('../constants/constants');

class ApiCalls {
    data;
    url;
    success;
    errorMessage = 'An error occurred while processing / retrieving data. Please try again or contact your System Administrator';
    extraOptions = null;
    method;

    constructor(data, url, success, errorMessage, extraOptions, method = 'POST')
    {
        this.data = data;
        this.url = url;
        this.success = success;
        this.errorMessage = errorMessage;
        this.extraOptions = extraOptions;
        this.method = method;
    }

    dispatch(){
        let ajaxOptions = {
            url: this.url,
            type: this.method,
            dataType: 'json',
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            data: this.data,
            success: this.success,
            error: (e) => {
                backdrop.hide();
                if(e.status === 422){
                    let errors = e.responseJSON.errors;
                    this.errorMessage = '<ul>'

                    $.each(errors, (i, v) => {
                        let formInput = $(document).find('[name="'+i+'"]');
                        formInput.addClass('is-invalid');
                        $.each(v, (iteration, value) => {
                            formInput.siblings('.invalid-feedback').html(value);
                            this.errorMessage += '<li>' + value + '</li>';
                        })
                    })

                    this.errorMessage += '</ul>'
                }
                Toast.fire({
                    icon: 'error',
                    title: this.errorMessage
                })
            }
        }
        if(this.extraOptions !== ''){
            $.extend(ajaxOptions, this.extraOptions)
        }
        $.ajax(ajaxOptions);
     }
}

module.exports = ApiCalls;
